import { useQuery } from '@tanstack/react-query';
import { MeApi } from 'src/api';
import { DailyNewWordsResponse } from 'src/api/me/types';

/**
 * Whether the learner crossed their daily new-words goal during this session: below it when
 * the session started, at or above it now. Shares its cache with the blob navbar counters,
 * so refetching here also refreshes them.
 */
export const useReachedDailyGoal = (
  languagePairId: number | null,
  dailyNewWordsBefore: DailyNewWordsResponse | undefined,
) => {
  const couldReachGoal =
    languagePairId !== null &&
    !!dailyNewWordsBefore &&
    dailyNewWordsBefore.startedToday < dailyNewWordsBefore.goal;

  const { data, isLoading } = useQuery({
    queryKey: ['dailyNewWords', languagePairId],
    queryFn: () => MeApi.getDailyNewWords(languagePairId as number),
    enabled: couldReachGoal,
    refetchOnMount: 'always',
  });

  return {
    isLoading: couldReachGoal && isLoading,
    hasReachedDailyGoal: couldReachGoal && !!data && data.startedToday >= data.goal,
  };
};
